export default "__VITE_ASSET__88dfa593__"